import { useEffect, useState } from "react";

export default function BoardFundraisingPhotoEditor({ client }) {
  const [photo, setPhoto] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { client.get("/admin/board-fundraising/event-photo").then(r => setPhoto(r.data)).catch(() => {}); }, [client]);
  const upload = async file => {
    if (!file) return;
    setBusy(true); setError("");
    try {
      if (file.size > 12 * 1024 * 1024) throw new Error("Choose the original JPEG under 12 MB.");
      const data = await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(String(reader.result).split(",")[1]); reader.onerror = reject; reader.readAsDataURL(file); });
      const response = await client.put("/admin/board-fundraising/event-photo", { filename: file.name, image_base64: data });
      setPhoto(response.data);
    } catch (err) { setError(err.response?.data?.detail || err.message || "The photograph could not be saved."); }
    finally { setBusy(false); }
  };
  const src = photo?.photo_url ? (process.env.REACT_APP_BACKEND_URL || "") + photo.photo_url : "";
  return <section className="bf-admin-live-panel"><h3>Event photograph</h3>
    <p>Your supplied event photograph appears on registration pages and social previews. You can replace it here at any time.</p>
    {src && <img src={src} alt="Current event photograph" width={photo.photo_width} height={photo.photo_height} style={{ maxWidth: 280, height: "auto" }}/>}
    <label>Original event photo<input type="file" accept="image/jpeg,.jpg,.jpeg" disabled={busy} onChange={e => upload(e.target.files?.[0])}/></label>
    {busy && <p>Saving photograph…</p>}{error && <p role="alert">{error}</p>}
  </section>;
}
